/**
 * @file 处方打印
 * print('url')
 * 多张图片：
 * print([url1, url2])
 * */
import Vue from 'vue';
import PrintImg from './index.vue';
import PrintPDF from './printPDF.vue';
import { Message } from 'element-ui';
import debounce from 'lodash/debounce';

const PrintImageFactory = Vue.extend(PrintImg);
const PrintPDFFactory = Vue.extend(PrintPDF);

let instance = null;
let pdfInstance = null;

const replaceProtocol = url => {
  return url.replace(/^http(s|):/, '');
};

/**
 * @param {String | Array} source
 * */
const printImg = debounce(
  (source, cb, type = 'image') => {
    let data = source || [];
    if (!Array.isArray(source)) {
      data = [source];
    }
    if (data.length === 0) return Message.warning('请选择图片');

    if (type === 'image') {
      if (!instance) {
        instance = new PrintImageFactory();
        instance.vm = instance.$mount();
        document.body.appendChild(instance.vm.$el);
      }
      // 提取出图片地址
      const propsImageSrc = data.map(v =>
        typeof v === 'string' ? replaceProtocol(v) : replaceProtocol(v.prescriptionImg)
      );

      instance.init(propsImageSrc, cb);
    } else {
      if (!pdfInstance) {
        pdfInstance = new PrintPDFFactory();
        pdfInstance.vm = pdfInstance.$mount();
        document.body.appendChild(pdfInstance.vm.$el);
      }

      pdfInstance.init(data, cb);
    }
  },
  300,
  { trailing: false, leading: true }
);

export default printImg;
